import { fetchGet } from "..";
import { APIResponse } from "../../types/responses/APIResponse";
import {
  Tipster,
  TipsterExpertEye,
  Tipsters,
  TipstersExpertEye,
} from "../../types/tipster";
import { isParamFriendlyDateFormat } from "../../utils/validParams";

// Tipsters API
export const getTipster = async (
  slug: string
): Promise<APIResponse<Tipster>> => {
  return await fetchGet(`racing/tips/tipsters/${slug}`);
};

// Tips API
export const getAllTips = async (date): Promise<APIResponse<Tipsters>> => {
  return await fetchGet(`/racing/tips/${date}/tipsters`);
};

// Get tip articles by date
export const getTipArticlesByDate = async (date): Promise<APIResponse<any>> => {
  return await fetchGet(`/news/articles/tipping/${date}`);
};

export const getFutureTipArticles = async (): Promise<APIResponse<any>> => {
  return await fetchGet(`/news/articles/tipping/future`);
};

// Tipster Tips API
export const getTipsterTips = async (
  tipsterSlug
): Promise<APIResponse<Tipster>> => {
  return await fetchGet(`/racing/tips/tipsters/${tipsterSlug}`);
};

// Tips by race API
export const getTipsByRace = async (
  track: string,
  date: string,
  race: string
): Promise<APIResponse<any>> => {
  return await fetchGet(`/racing/racecards/${track}/${date}/${race}/tips`);
};

export const getTipVideos = async (
  future = false
): Promise<APIResponse<any>> => {
  return await fetchGet(`/racing/tips/${future ? "future-" : ""}videos`);
};

export const getExpertEyeTips = async (
  date?: string
): Promise<APIResponse<TipstersExpertEye>> => {
  if (isParamFriendlyDateFormat(date))
    return await fetchGet(`/racing/tips/tracked-horse-videos/${date}`);
  else throw new Error("Invalid date format");
};

// Future tips not including today or tomorrow
export const getFutureTips = async (): Promise<APIResponse<any>> => {
  return await fetchGet(`/racing/tips/future`);
};
